import { Entity } from '../entity.js';

export function createSivir(id = 'sivir-1', team = 'blue', x = 300, y = 1300) {
  const sivir = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 545,
    maxMp: 250,
    ad: 63,
    ap: 0,
    armor: 25,
    mr: 30,
    ms: 335,
    attackRange: 500,
    attackSpeed: 0.625,
    name: 'Sivir',
    radius: 20
  });
  sivir.spellShieldActive = false;
  sivir.onTheHuntActive = false;
  sivir.ricochetActive = false;
  sivir.ricochetCharges = 0;
  return sivir;
}

export function castSivirQ(caster, targetX, targetY, projectiles, gameTime) {
  if (caster.mp < 55) return false;
  caster.mp -= 55;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 70 + caster.ad * 1.0 + (caster.ap || 0) * 0.5;
  projectiles.push({
    id: `sivir-q-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * 1450,
    vy: Math.sin(angle) * 1450,
    range: 1250,
    traveled: 0,
    damage,
    damageType: 'physical',
    isBoomerang: true,
    radius: 16
  });
  return true;
}

export function castSivirW(caster) {
  if (!caster || caster.isDead || caster.mp < 60) return false;
  caster.mp -= 60;
  caster.ricochetActive = true;
  caster.ricochetCharges = 3;
  return true;
}

export function castSivirE(caster) {
  if (caster.mp < 50) return false;
  caster.mp -= 50;
  caster.spellShieldActive = true;
  return true;
}

export function castSivirR(caster) {
  if (caster.mp < 100) return false;
  caster.mp -= 100;
  caster.onTheHuntActive = true;
  caster.ms += 70;
  return true;
}
